import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Delivery, DeliveryStatus, DeliveryStatusAux } from 'src/app/models/delivery.schema';
import { Partner } from 'src/app/models/partner.schema';
import { PartnerInvoiceService } from 'src/app/services/partner-invoice.service';
import { PartnerService } from 'src/app/services/partner.service';
import { PartnerInvoiceFormComponent } from '../partner-invoice-form/partner-invoice-form.component';
import { ServiceModel } from 'src/app/models/service.schems';
import { Service } from 'src/app/services/service.service';
import { FormControl, FormGroup } from '@angular/forms';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaginationComponent } from '../_pagination/pagination.component';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { DeliveryService } from 'src/app/services/delivery.service';
import { Expert } from 'src/app/models/expert.schema';
import { ExpertService } from 'src/app/services/expert.service';
import { DeliveryObserverService } from 'src/app/services/observers/delivery-observer.service';
import { SpinnerService } from './../../services/spinner.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { DeliveryComplaintPopUpComponent } from '../delivery-complaint-pop-up/delivery-complaint-pop-up.component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Product } from 'src/app/models/product.schema';
@Component({
  selector: 'app-partner-invoice',
  templateUrl: './partner-invoice.component.html',
  styleUrls: ['./partner-invoice.component.scss']
})
export class PartnerInvoiceComponent implements OnInit {
  public groups: any;
  public _deliveryFilterForm;
  public deliveryStatus = DeliveryStatus;
  public deliveryStatusAux = DeliveryStatusAux;
  public deliveries: Delivery[] = [];
  public limit: number;
  public page: number;
  public count: number = 0;
  public maxPage: number;
  public order: {};
  public experts: Expert[];
  public expertDialogOpen: number;
  public selectedPartnerId: any = null;
  public partners: Partner[] = [];
  public selectedPartner: any;
  public selectedDeliveries: Delivery[] = [];
  public services: ServiceModel[] = [];
  @ViewChild(PaginationComponent, { static: false }) paginationComponent: PaginationComponent;
  public selected = "";
  public settings = {
    active: {
      title: "Fatturazione",
    },
    inactive: {
      title: "Storico Fatturazione",
    }
  };
  private readonly tableSpacing = {
    admin: {
      id: 5,
      deliveryDate: 10,
      time: 10,
      partner: 15,
      expert: 10,
      address: 30,
      status: 5,
      detail: 5,
      edit: 5,
      assignExpert: 5,
      historyStatus: 5,
    },
    partner: {
      id: 5,
      deliveryDate: 10,
      time: 10,
      address: 20,
      status: 5,
      detail: 10,
      edit: 10,
      historyStatus: 5,
    },
    expert: {
      id: 5,
      deliveryDate: 10,
      time: 15,
      partner: 10,
      address: 20,
      status: 10,
      edit: 20,
      detail: 10,
      historyStatus: 5,
    },
  };
  public defaultPage = 1;
  public defaultLimit = 100;
  public defaultOrder = { 'Delivery.deliveryDate': 'DESC', 'Delivery.fromTime': 'ASC', 'Delivery.toTime': 'ASC' };
  public filtered = {};
  public today: any;
  disableBtn: boolean = false;
  grandTotalValues = {
    valoreProdotto: 0,
    fee: 0,
    prezzo: 0,
    plusMinusPrezzo: 0,
    valore: 0,
    valoreIva: 0,
    totale: 0
  }


  public groupWhitelisted(groups: string | string[]): boolean {
    if (!Array.isArray(groups))
      return this.groups.includes(groups);
    for (let group of groups)
      if (this.groups.includes(group))
        return true;
    return false;
  }

  public getSpacing(property) {
    if (this.groups.includes('expert'))
      return this.tableSpacing['expert'][property] || 0;
    if (this.groups.includes('partner'))
      return this.tableSpacing['partner'][property] || 0;
    if (this.groups.includes('admin'))
      return this.tableSpacing['admin'][property] || 0;
  }

  constructor(
    private authStatusService: AuthStatusService,
    private deliveryService: DeliveryService,
    public deliveryObserverService: DeliveryObserverService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    public expertService: ExpertService,
    public partnerService: PartnerService,
    private partnerInvoiceService: PartnerInvoiceService,
    public service: Service,
    public spinnerService: SpinnerService,
    public commanUsesService: CommanUsesService,
  ) {
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    this.selected = !this.route.snapshot.data['active'] ? 'inactive' : 'active';
  }


  async ngOnInit() {
    try {
      this.spinnerService.show();
      if(this.groups.includes('partner')){
        let loggedInPartner = JSON.parse(sessionStorage.getItem("currentUser"));
        this.selectedPartner = await this.partnerService.getOne(loggedInPartner?.partner?.id);
        if(!this.selectedPartner.billingAccess) {
          this.router.navigate(['/404']);
        }
      }
      this.handleFilterForm();
      var today = new Date();
      var tmptoday = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2);
      this.today = tmptoday;
      this.expertDialogOpen = 0;
      await this.initialize();
      await this.filter();
      this.spinnerService.hide();
    } catch (error) {
      this.snack("Something went wrong on this page");
    }
  }


  handleFilterForm(){
    this._deliveryFilterForm = new FormGroup({
      'Delivery.id': new FormControl(''),
      'Delivery.deliveryDate_from': new FormControl(''),
      'Delivery.deliveryDate_to': new FormControl(''),
      'Delivery.fromTime': new FormControl(''),
      'Delivery.toTime': new FormControl(''),
      'Partner.businessName': new FormControl(''),
      'UserExpert.surname': new FormControl(''),
      'Delivery.status': new FormControl(''),
      'Delivery.address': new FormControl(''),
      'Delivery.partner.address': new FormControl(''),
      'Delivery.pickUpTime': new FormControl(''),
      'Delivery.price': new FormControl(''),
      'Service.pricingModel': new FormControl(''),
      'Service.serviceName': new FormControl(''),
      'Delivery.invoiced': new FormControl(''),
      'Delivery.serviceType': new FormControl(''),
      'Delivery.billable': new FormControl(''),
      'Delivery.additionalPrice': new FormControl(''),
      'Delivery.productValue': new FormControl(''),
      'Delivery.paidViaCard': new FormControl(''),
      'Delivery.ddtNumber': new FormControl(''),
      // 'Delivery.withDailyDeliveryRule': new FormControl(''),
      // 'Delivery.withTotalDeliveryRule': new FormControl(''),
    });
  }


  async initialize() {
    if(this.groups.includes('admin') || this.groups.includes('operation')) {
      await this.getAllPartners();
    }
    await this.getAllService();
  }


  public invoiceModal() {
    if(this.selectedPartner === null || this.selectedPartner == undefined ){
      alert('Please select partner first');
      return false;
    }

    let filterForm = (new FormGroupToObject()).transform(this._deliveryFilterForm);

    let ref = this.dialog.open(PartnerInvoiceFormComponent, {maxWidth: '95%', data: {
      deliveries: this.selectedDeliveries,
      partner: this.selectedPartner,
      historyPage: this.selected,
      fromDate: filterForm['Delivery.deliveryDate_from'],
      toDate: filterForm['Delivery.deliveryDate_to']
    } });
    ref.afterClosed().subscribe(async (result) => {
      if(result?.success){

        // Remove only those deliveries that were invoiced
        this.deliveries = this.deliveries.filter(
          d => !this.selectedDeliveries.includes(d)
        );

        this.count = this.deliveries.length;

        // this.selectedDeliveries = [];
        // this.expertDialogOpen = 0;
        // this.selectedPartner = null;
        // this.selectedPartnerId = null;
        // await this.loadDeliveries();
      }
    });
  }

  isSelected(delivery: any): boolean {
    return this.selectedDeliveries.includes(delivery);
  }


  selectAllDeliveries(): void {
    const allDeliveriesSelected = this.selectedDeliveries.length === this.deliveries.length;
    this.selectedDeliveries = allDeliveriesSelected ? [] : [...this.deliveries];
  }

  toggleSelection(delivery: any): void {
      if (this.isSelected(delivery)) {
          this.selectedDeliveries = this.selectedDeliveries.filter(item => item !== delivery);
      } else {
          this.selectedDeliveries.push(delivery);
      }
  }

  async filter() {

    let filterForm = (new FormGroupToObject()).transform(this._deliveryFilterForm);
    this.filtered = {};

    if (filterForm['Delivery.id'])
      this.filtered['Delivery.id'] = filterForm['Delivery.id'];
    if (filterForm['Delivery.deliveryDate_from'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'moreThanOrEqual', values: [filterForm['Delivery.deliveryDate_from']] };
    if (filterForm['Delivery.deliveryDate_to'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'lessThan', values: [filterForm['Delivery.deliveryDate_to']] };
    if (filterForm['Delivery.deliveryDate_from'] && filterForm['Delivery.deliveryDate_to'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'between', values: [filterForm['Delivery.deliveryDate_from'], filterForm['Delivery.deliveryDate_to']] };
    if (filterForm['Delivery.fromTime'])
      this.filtered['Delivery.fromTime'] = { operator: 'moreThanOrEqual', values: [filterForm['Delivery.fromTime']] };
    if (filterForm['Delivery.toTime'])
      this.filtered['Delivery.toTime'] = { operator: 'lessThan', values: [filterForm['Delivery.toTime']] };
    if (filterForm['Delivery.pickUpTime'])
      this.filtered['Delivery.pickUpTime'] = { operator: 'moreThanOrEqual', values: [filterForm['Delivery.pickUpTime']] };
      if (filterForm['Delivery.status'])
      this.filtered['Delivery.status'] = filterForm['Delivery.status'];
    if (filterForm['Delivery.address'])
       this.filtered['Delivery.address'] = { operator: 'like', values: [`%${filterForm['Delivery.address']}%`]};
      this.filtered['Delivery.receiverPhone'] = filterForm['Delivery.receiverPhone'];
    if (filterForm['Delivery.deliveryDate'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'like', values: [`%${filterForm['Delivery.deliveryDate']}%`] };
    if (filterForm['Delivery.time'])
      this.filtered['Delivery.time'] = { operator: 'like', values: [`%${filterForm['Delivery.time']}%`] };
    if (filterForm['Partner.businessName'])
      this.filtered['Partner.businessName'] = { operator: 'like', values: [`%${filterForm['Partner.businessName']}%`] };
    if (filterForm['UserExpert.surname'])
      this.filtered['UserExpert.surname'] = { operator: 'like', values: [`%${filterForm['UserExpert.surname']}%`], concat: [{ string: ' ' }, { column: 'UserExpert.name' }] };
    if (filterForm['Delivery.address'])
      this.filtered['Delivery.address'] = { operator: 'like', values: [`%${filterForm['Delivery.address']}%`]};
    if (filterForm['Service.serviceName'])
      this.filtered['Service.serviceName'] = { operator: 'like', values: [`%${filterForm['Service.serviceName']}%`]};
    if (filterForm['Service.pricingModel'])
      this.filtered['Service.pricingModel'] = { operator: 'like', values: [`%${filterForm['Service.pricingModel']}%`]};
    if (filterForm['Delivery.partner.address'])
      this.filtered['Delivery.partner.address'] = { operator: 'like', values: [`%${filterForm['Delivery.partner.address']}%`], concat: [{ string: ' ' }, { column: 'Delivery.partner.address' }] };
    if (filterForm['Delivery.price'])
      this.filtered['Delivery.price'] = { operator: 'like', values: [`%${filterForm['Delivery.price']}%`]};
    if (filterForm['Delivery.additionalPrice'])
      this.filtered['Delivery.additionalPrice'] = { operator: 'like', values: [`%${filterForm['Delivery.additionalPrice']}%`]};
    if (filterForm['Delivery.serviceType'])
      this.filtered['Delivery.serviceType'] = { operator: 'like', values: [`%${filterForm['Delivery.serviceType']}%`]};
    if (filterForm['Delivery.billable'])
      this.filtered['Delivery.billable'] = { operator: 'like', values: [`%${filterForm['Delivery.billable']}%`]};
    if (filterForm['Delivery.productValue'])
      this.filtered['Delivery.productValue'] = { operator: 'like', values: [`%${filterForm['Delivery.productValue']}%`]};
    if (filterForm['Delivery.paidViaCard'])
      this.filtered['Delivery.paidViaCard'] = { operator: 'like', values: [`%${filterForm['Delivery.paidViaCard']}%`]};
    if (filterForm['Delivery.ddtNumber'])
      this.filtered['Delivery.ddtNumber'] = { operator: 'like', values: [`%${filterForm['Delivery.ddtNumber']}%`]};
    // if (filterForm['Delivery.withDailyDeliveryRule'])
    //   this.filtered['Delivery.withDailyDeliveryRule'] = { operator: 'like', values: [`%${filterForm['Delivery.withDailyDeliveryRule']}%`]};
    // if (filterForm['Delivery.withTotalDeliveryRule'])
    //   this.filtered['Delivery.withTotalDeliveryRule'] = { operator: 'like', values: [`%${filterForm['Delivery.withTotalDeliveryRule']}%`]};
    // this.navigate(event);
    await this.loadDeliveries();
  }

  async fnReset() {
    this._deliveryFilterForm = new FormGroup({
      'Delivery.id': new FormControl(''),
      'Delivery.deliveryDate_from': new FormControl(),
      'Delivery.deliveryDate_to': new FormControl(),
      'Delivery.fromTime': new FormControl(''),
      'Delivery.toTime': new FormControl(''),
      'Partner.businessName': new FormControl(''),
      'UserExpert.surname': new FormControl(''),
      'Delivery.status': new FormControl(''),
      'Delivery.address': new FormControl(''),
      'Delivery.receiverPhone': new FormControl(''),
      'Delivery.deliveryDate': new FormControl(''),
      'Delivery.time': new FormControl(''),
      'Delivery.pickUpTime': new FormControl(''),
      'Delivery.partner.address': new FormControl(''),
      'Delivery.price': new FormControl(''),
      'Delivery.additionalPrice': new FormControl(''),
      'Service.pricingModel': new FormControl(''),
      'Service.serviceName': new FormControl(''),
      'Delivery.invoiced': new FormControl(''),
      'Delivery.serviceType': new FormControl(''),
      'Delivery.billable': new FormControl(''),
      'Delivery.productValue': new FormControl(''),
      'Delivery.paidViaCard': new FormControl(''),
      'Delivery.ddtNumber': new FormControl(''),
      // 'Delivery.withDailyDeliveryRule': new FormControl(''),
      // 'Delivery.withTotalDeliveryRule': new FormControl(''),
    });
    this.expertDialogOpen = 0;
    this.selected = !this.route.snapshot.data['active'] ? 'inactive' : 'active';
    this.deliveries = [];
    this.count = 0;
    this.selectedPartner = null;
    this.selectedPartnerId = null;
  }

  navigate(event) {
    this.loadDeliveries(event.limit, event.page, this.order);
  }

  async loadDeliveries(limit?: number, page?: number, order?: {}) {
    let filterForm = (new FormGroupToObject()).transform(this._deliveryFilterForm);
    if(filterForm['Delivery.deliveryDate_to'] && filterForm['Delivery.deliveryDate_from']){
      if((this.today != filterForm['Delivery.deliveryDate_from'])){
        this.defaultOrder = { 'Delivery.deliveryDate': 'ASC', 'Delivery.fromTime': 'ASC', 'Delivery.toTime': 'ASC' };
      }
    }

    this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
    this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
    this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;

    let deliveries: any;
    if(this.selected == 'active'){
      this.filtered['Delivery.invoiced'] = { operator: 'equal', values: [0]};
      deliveries = await this.partnerInvoiceService.getAllDeliveries(this.selectedPartner?.id, this.page, this.limit, this.order, this.filtered);
    } else {
      this.filtered['Delivery.invoiced'] = { operator: 'equal', values: [1]};
      deliveries = await this.partnerInvoiceService.getAllDeliveries(this.selectedPartner?.id, this.page, this.limit, this.order, this.filtered);
    }
    this.deliveries = deliveries.deliveries;
    this.count = deliveries.count;
    this.maxPage = Math.ceil(this.count / this.limit);
    this.generateGrandTotalValues();

  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    if(this.order){
      for (let attr of attribute) {
        switch (this.order[attr]) {
          case 'ASC':
            return 'fa-sort-up';
          case 'DESC':
            return 'fa-sort-down';
          default:
            return 'fa-sort';
        }
      }
    }
  }

  public navigateOrder(attribute: string | string[]) {
    if(this.order){
      delete this.order['Delivery.updatedAt'];
    }
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    if(this.order){
      for (let attr of attribute) {
        switch (this.order[attr]) {
          case 'ASC':
            this.order[attr] = 'DESC';
            break;
          case 'DESC':
            this.order[attr] = undefined;
            break;
          default:
            this.order = {}
            this.order[attr] = 'ASC';
            break;
        }
      }
    }

    this.navigatePage(this.limit, this.page, { order: this.order });
  }

  snack(message: string) {
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    });
  }

  navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(data => {
      this.loadDeliveries();
    });
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }


  formatTimeShow(fromTime, toTime){
    let trimmedFromTime = fromTime != null ? fromTime?.slice(0, -3) : '';
    let trimmedToTime = toTime != null ? toTime?.slice(0, -3) : '';
    let time = trimmedFromTime + '-' + trimmedToTime;
    return time;
  }

  async getAllPartners(){
    try {
      // this.partners = (await this.partnerService.getAllActivePartners(undefined, undefined, { 'Partner.businessName': 'ASC' })).partners;
      this.partners = await this.partnerService.getAllActivePartnersForDelivery().then(res => res.partners);
    }
    catch { }
  }
  async handlePartnerChange(partnerId: any){
    try {
      this.spinnerService.show();
      this.selectedDeliveries = [];
      this.selectedPartner = this.partners.find((partner) => {
        return partner?.id == partnerId;
      });
      this.selectedPartnerId = this.selectedPartner?.id;
      await this.loadDeliveries();
      this.spinnerService.hide();
    } catch (error) {
      this.snack("Somthing went wrong");
    }
  }

  async getAllService(){
    try {
      const services = await this.service.getAllServicess();
      this.services = services.services;
    }
    catch { }
  }

  showServiceDetails(serviceId: number){
    if(serviceId){
      const service = this.services.find((service) => service.id == serviceId);
      return service;
    }
  }

  async complainForDeliveryBilling(delivery: Delivery) {
    try {
      this.disableBtn = true;
      let ref = this.dialog.open(DeliveryComplaintPopUpComponent, { width: '50vw', data: { delivery } });
      ref.afterClosed().subscribe(async (result) => {});
      this.disableBtn = false;
    } catch (error) {
      console.log("ERROR", error);
      this.disableBtn = false;
    }
  }

  showServiceDetailsPartner(serviceId: number){
    if(serviceId){
      const service = this.selectedPartner?.partnerServices.find((item) => {
        return item?.service?.id == serviceId;
      });
      return service;
    }
  }

  commanForValuesOld(delivery: Delivery) {
    let totals = {
      valoreProdotto: 0,
      fee: 0,
      prezzo: 0,
      plusMinusPrezzo: 0,
      valore: 0,
      valoreIva: 0,
      totale: 0
    };

    
    if(delivery.id == 54752) {
      console.log("delivery", delivery)
    }
  
    if(!delivery?.billable){
      return totals;
    }
    
    let serviceDetailsPartner = this.showServiceDetailsPartner(Number(delivery?.service));
    let pricingModel = serviceDetailsPartner?.service?.pricingModel?.toLowerCase() || '';
  
    const IS_SALE_SERVICE = pricingModel === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL;
    const IS_CORPORATE_SERVICE = pricingModel === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL;
    const IS_FIXED_PRICE_SERVICE = pricingModel === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL;
    const IS_HOURLY_RATE_SERVICE = pricingModel === APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL;
    const IS_WAREHOUSE_SERVICE = pricingModel === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL;
  
    totals.valoreProdotto = Number(delivery?.productValue) || 0;
    totals.fee = Number(serviceDetailsPartner?.price) || 0;
    // totals.fee = delivery.deliveryWithoutCommision ? 0: Number(serviceDetailsPartner?.price) || 0;
    totals.prezzo = Number(delivery?.price) || 0;
    // totals.prezzo = delivery.deliveryWithoutCommision ? 0 : Number(delivery?.price) || 0;
    totals.plusMinusPrezzo = Number(delivery?.additionalPrice) || 0;
    totals.valore = totals.prezzo + totals.plusMinusPrezzo;
    totals.valoreIva = totals.valore * 0.22;
  
    if (IS_FIXED_PRICE_SERVICE || IS_HOURLY_RATE_SERVICE || IS_WAREHOUSE_SERVICE) {
      let value = (Number(delivery?.price) || 0) + (Number(delivery?.additionalPrice) || 0);
      // let value = (Number(delivery.deliveryWithoutCommision ? 0 : delivery?.price) || 0) + (Number(delivery?.additionalPrice) || 0);
      let valuePlusVat = value + (value * 0.22);
      totals.totale = valuePlusVat;
    }
  
    if (IS_CORPORATE_SERVICE) { 
      let baseValue = (Number(delivery?.price) || 0) + (Number(delivery?.additionalPrice) || 0);
      // let baseValue = (Number(delivery.deliveryWithoutCommision ? 0 : delivery?.price) || 0) + (Number(delivery?.additionalPrice) || 0);
      let productPrice = Number(delivery?.deliveryProducts?.[0]?.price) || 0;
      totals.totale = baseValue + productPrice;
    }
  
    if (IS_SALE_SERVICE) {
      let price = Number(delivery?.price) || 0;
      // let price = Number(delivery.deliveryWithoutCommision ? 0 : delivery?.price) || 0;
      let pricePlusVat = price + (price * 0.22);
      let valueMinusPriceVat = (Number(delivery?.productValue) || 0) - pricePlusVat;
      totals.totale = valueMinusPriceVat + (Number(delivery?.additionalPrice) || 0);
    }
  
    return totals;
  }
  

  generateGrandTotalValues(){

    this.grandTotalValues = {
      valoreProdotto: 0,
      fee: 0,
      prezzo: 0,
      plusMinusPrezzo: 0,
      valore: 0,
      valoreIva: 0,
      totale: 0
    }

    this.deliveries.forEach((delivery: any) => {
      this.grandTotalValues.valoreProdotto += this.commanForValues(delivery).valoreProdotto;
      this.grandTotalValues.fee += this.commanForValues(delivery).fee;
      this.grandTotalValues.prezzo += this.commanForValues(delivery).prezzo;
      this.grandTotalValues.plusMinusPrezzo += this.commanForValues(delivery).plusMinusPrezzo;
      this.grandTotalValues.valore += this.commanForValues(delivery).valore;
      this.grandTotalValues.valoreIva += this.commanForValues(delivery).valoreIva;
      this.grandTotalValues.totale += this.commanForValues(delivery).totale;
    });
  }

  complaintAlredayRegistered(delivery: Delivery) {
    return delivery?.deliveryComplaints?.some(c => c?.partner?.id === this.selectedPartner?.id);
  }

  async exportPartnerInvoice() {
    try {
      if (!this.selectedDeliveries.length) {
        this.commanUsesService.showSnackBar('Seleziona prima le consegne');
        return;
      }

      const data = this.selectedDeliveries.map((d) => {
        const totals = this.commanForValues(d);
        const service = d?.serviceType?.toLowerCase();
        const pricingModel = service === "fixedprice"
            ? "Servizi a Prezzo Fisso"
            : service === "hourlyrate"
            ? "Servizi a Ora"
            : service === "sales"
            ? "Servizi Vendita"
            : service === "corporate"
            ? "Corporate Servizi"
            : "";

        return {
          'STATO': d.status,
          'ID VENDITA': d.ddtNumber,
          'ID CONSEGNA': d.id,
          'DATA': d?.deliveryDate
              ? new Date(d.deliveryDate).toLocaleDateString('it-IT')
              : 'N/A',
          'ORARIO': (d?.fromTime && d?.toTime)
              ? `${d.fromTime} ${d.toTime}`
              : 'N/A',
          'PARTNER': d?.partner?.businessName || 'N/A',
          'VALET': d?.expert?.user
            ? `${d.expert.user.surname || ''} ${d.expert.user.name || ''}`.trim()
            : 'N/A',
          'NOTE': d?.notes || 'N/A',
          'INDIRIZZO': d?.address || 'N/A',
          'ORA RITIRO': d?.pickUpTime || 'N/A',
          'SERVIZIO TYPE': d?.serviceType || 'N/A',
          'VALORE PRODOTTO': totals.valoreProdotto,
          'FEE %': totals.fee.toFixed(2),
          'PREZZO': totals.prezzo.toFixed(2),
          'PLUS MINUS PREZZO': totals.plusMinusPrezzo.toFixed(2),
          'VALORE': totals.valore.toFixed(2),
          'VALORE + IVA': totals.valoreIva.toFixed(2),
          'TOTALE': totals.totale.toFixed(2)
        };
      });

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
      const workbook: XLSX.WorkBook = {
        Sheets: { 'Invoices': worksheet },
        SheetNames: ['Invoices']
      };

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      const blob: Blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });

      saveAs(blob, 'Partner_Fatturazione.xlsx');

    } catch (error) {
      console.log("ERROR", error);
    }
  }

  commanForValues(delivery: Delivery) {
    let totals = {
      valoreProdotto: 0,
      fee: 0,
      prezzo: 0,
      plusMinusPrezzo: 0,
      valore: 0,
      valoreIva: 0,
      totale: 0
    };

    if (!delivery?.billable) {
      return totals;
    }

    const serviceDetailsPartner = this.showServiceDetailsPartner(Number(delivery?.service));
    const pricingModel = serviceDetailsPartner?.service?.pricingModel?.toLowerCase() || '';

    const IS_SALE_SERVICE = pricingModel === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL;
    const IS_CORPORATE_SERVICE = pricingModel === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL;
    const IS_FIXED_PRICE_SERVICE = pricingModel === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL;
    const IS_HOURLY_RATE_SERVICE = pricingModel === APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL;
    const IS_WAREHOUSE_SERVICE = pricingModel === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL;

    const VAT = 0.22;

    // Base assignments
    totals.valoreProdotto = Number(delivery?.productValue) || 0;
    totals.fee = Number(serviceDetailsPartner?.price) || 0;
    totals.plusMinusPrezzo = Number(delivery?.additionalPrice) || 0;

    // =========================
    // SALE SERVICE (FIXED CLEAN)
    // =========================
    if (IS_SALE_SERVICE) {

      const totalSelectedProductPrice = (delivery.deliveryProducts || [])
        .map(item => {
          if (item.deliveryWithoutCommision) return 0;

          const product: Product = item.product;
          const productVariant = item?.productVariant;
          const quantity = item?.quantity || 1;

          let price = Number(product?.price) || 0;

          // Flexible pricing
          if (delivery.isFlexiblePrice && delivery.flexiblePrice) {
            try {
              const flexibleData = JSON.parse(delivery.flexiblePrice);
              const productData = flexibleData.find(
                (f) => f?.product?.id === product?.id
              );

              if (productData?.flexiblePrice != null) {
                price = Number(productData.flexiblePrice);
              }
            } catch {
              console.error("Invalid flexiblePrice JSON");
            }
          } else if (productVariant) {
            price = Number(productVariant.variantPrice) || 0;
          }

          return (!isNaN(price) && !isNaN(quantity)) ? price * quantity : 0;
        })
        .reduce((acc, curr) => acc + curr, 0);

      // const commissionPrice = (totalSelectedProductPrice * totals.fee) / 100;
      // const commissionPrice = (Number(delivery?.productValue || 0) * totals.fee) / 100;
      const commissionPrice = Number(delivery?.price || 0);

      totals.prezzo = commissionPrice;
      totals.valore = commissionPrice + totals.plusMinusPrezzo;
      totals.valoreIva = totals.prezzo + totals.valore * VAT;

      const priceWithVat = commissionPrice + (commissionPrice * VAT);
      const valueMinusPriceVat = totals.valoreProdotto - priceWithVat;

      totals.totale = valueMinusPriceVat + totals.plusMinusPrezzo;

      return totals; 
    }

    // =========================
    // DEFAULT FLOW
    // =========================
    totals.prezzo = Number(delivery?.price) || 0;
    totals.valore = totals.prezzo + totals.plusMinusPrezzo;
    totals.valoreIva = totals.valore * VAT;

    // ===========================
    // Fixed / Hourly / Warehouse
    // ===========================
    if (IS_FIXED_PRICE_SERVICE || IS_HOURLY_RATE_SERVICE || IS_WAREHOUSE_SERVICE) {
      const value = totals.valore;
      totals.totale = value + (value * VAT);
    }

    // ===========================
    // Corporate
    // ===========================
    /*
    if (IS_CORPORATE_SERVICE) {
      const baseValue = totals.valore;
      const productPrice = Number(delivery?.deliveryProducts?.[0]?.price) || 0;
      totals.totale = baseValue + productPrice;
    }
    */

    if (IS_CORPORATE_SERVICE) {
      const baseValue = totals.valore;
      const productPrice = (delivery.deliveryProducts || []).reduce((sum, item) => {
        return sum + (Number(item?.product?.price) || 0);
      }, 0);
      // totals.totale = totals.fee + productPrice;
      totals.totale = Number(totals.valore) + Number(totals.valoreIva || 0);
    }

    return totals;
  }
}

